export var SILENT = -1;
export var ERROR = 0;
export var WARN = 1;
export var INFO = 2;
export var DEBUG = 3;
export var DEBUG2 = 4;
export default Object.freeze({
  SILENT,
  ERROR,
  WARN,
  INFO,
  DEBUG,
  DEBUG2
});
//# sourceMappingURL=LoggerLevel.js.map